async function sendContactData(payload) {
  const body = JSON.stringify(payload)
  const response = await fetch(import.meta.env.VITE_QUIZ_PATH, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  })

  const resData = await response.json()
  return resData.data
}

export default function useQuiz() {
  return {
    sendContactData,
  }
}
